export const registrationForm = {
  registrationAlias: "Alias",
  registrationName: "Naam",
  registrationLastName: "Van",

  registrationEmail: "E-pos",
  registrationEmail_message: "Voer asseblief 'n geldige e-pos in",
  registrationEmail_required: "E-pos word vereis",
  registrationEmail_specialChar: "Spesiale karakters word nie toegelaat nie",
  registrationEmail_CharStartEnd: "E-pos kan nie met spesiale karakters begin of eindig nie",
  registrationEmail_CharConsecutive: "E-pos kan nie opeenvolgende spesiale karakters hê nie",

  registrationPhoneNumber: "Foonnommer",
  registrationPhoneNumber_message: "Voer asseblief 'n geldige foonnommer in",
  registrationPhoneNumber_tooltip: "Jou foonnommer sal gebruik word om jou mobiele betaling te valideer.",
  registrationBirthdate: "Geboortedatum",
  registrationBirthdate_message: "Jy moet 18 jaar oud wees om te registreer",
  registrationNational_id: "ID-nommer",
  registrationId_message: "Voer asseblief jou ID-nommer in",
  registrationNationalIdNumbersOnly: "Slegs syfers van 0 tot 9 word toegelaat",
  state: "Staat",
  registrationState: "Staat",
  registrationSelect_state: "Kies Staat",
  registrationCity: "Stad",
  registrationSelect_city: "Kies Stad",
  registrationSelectDate: "Geboortedatum",
  registrationPassword: "Wagwoord",
  registrationRepeatPassword: "Herhaal wagwoord",
  registrationRepeatPassword_required: "Herhaal asseblief jou wagwoord",
  registrationPasswordNotMatch: "Wagwoorde stem nie ooreen nie",
  registrationPasswordMinLength: "Wagwoord moet ten minste 8 karakters lank wees",
  registrationReferralCode: "Verwysingskode (Opsioneel)",
  registrationTermsAndConditions: "bepalings en voorwaardes",
  registrationTermsAndConditions_: "Ek aanvaar die",
  registrationAcceptTerms: "Jy moet die bepalings en voorwaardes aanvaar",
  registrationAcceptTermsAgeCondition: "En ouer as 18 jaar wees",
  registrationAcceptTermsRegister: "Registreer",

  registrationAliasUnavailable: "Hierdie alias is reeds in gebruik, probeer 'n ander een",
  registrationAliasChecking: "Kontroleer aliasbeskikbaarheid...",
  registrationAliasAvailable: "Hierdie alias is beskikbaar",

  registrationAccountValidationModal: "Registrasiefout",
  registrationValidationModalEmail:
    "Hierdie gebruiker is reeds in die stelsel geregistreer. Teken asseblief in of gebruik 'n ander e-posadres om te registreer.",
  registrationValidationModalPhone: "Foonnommer reeds geregistreer, gebruik asseblief 'n ander foonnommer.",
  registrationValidationModalId: "ID-nommer reeds geregistreer, gebruik asseblief 'n ander ID-nommer.",
  registrationValidationModalError: "Daar was 'n fout, kontroleer asseblief jou data.",

  // E-posverifikasiekennisgewing (verouderd - nou outo-inteken)
  registrationEmailVerificationTitle: "E-posverifikasie",
  registrationEmailVerificationMessage:
    "'n Verifikasieskakel is na jou e-posadres gestuur. Kontroleer asseblief jou inkassie en klik die skakel om jou rekening te verifieer.",

  registrationBonusTitle: "Voorkeurbonus",
  registrationFormBonusSlot: "Slots",
  registrationFormBonusCasino: "Lewendige casino",
  registrationFormBonusParley: "Parley",

  registrationSuccessTitle: "Registrasie suksesvol!",
  registrationSuccessMessage: "Welkom! Jy is outomaties ingeteken.",
  registrationError: "Registrasiefout",
  registrationErrorMessage:
    "Registrasie is voltooi, maar ons kon jou nie outomaties inteken nie. Teken asseblief handmatig in.",
};
